'use client';

import {
  ISalePageDetailResponse,
  ISalePageProductAdditionalInformResponse,
} from '@/api/types';
import { CTA } from '@/components';
import { useUserQuery } from '@/entities';
import { qaAttr, qaId } from '@/lib/qa';
import { Skeleton } from '@vuddy/components';
import { isNil } from 'lodash-es';
import { ClassPurchase } from '../bottomSheet/physical/ClassPurchase';
import { EndedCTA, OnSaleCTA, PlannedCTA } from '../cta';
import * as styles from './purchaseCTAButton.css';

export interface PurchaseCTAButtonProps {
  salePage?: Partial<ISalePageDetailResponse>;
  productAdditionalInforms?: ISalePageProductAdditionalInformResponse[];
  interactive?: boolean;
}

export const PurchaseCTAButton = ({
  salePage,
  productAdditionalInforms,
  interactive = true,
}: PurchaseCTAButtonProps) => {
  const { data: userData, isLoading: isUserLoading } = useUserQuery();
  const canRenderClassPurchase =
    salePage?.type === 'CLASS' &&
    !!salePage.id &&
    !!salePage.channelId &&
    !!salePage.clazz;

  return (
    <CTA
      {...qaAttr(qaId('sale.purchase', 'cta'))}
      direction="vertical"
      position="sticky"
      styleName={styles.ctaSlideUpAnimation}>
      {isNil(salePage?.saleStatus) || isUserLoading ? (
        <Skeleton height="52px" />
      ) : salePage.saleStatus === 'PLANNED' ? (
        isNil(salePage.saleTimeRange?.startAt) ? null : (
          <PlannedCTA openDate={salePage.saleTimeRange.startAt} />
        )
      ) : salePage?.saleStatus === 'ON_SALE' ? (
        canRenderClassPurchase ? (
          <ClassPurchase
            salePage={{
              id: salePage.id!,
              name: salePage.name!,
              channelId: salePage.channelId!,
              channel: salePage.channel!,
              type: 'CLASS',
              clazz: salePage.clazz!,
            }}
            forceFetchAdditionalInforms
          />
        ) : (
          <OnSaleCTA
            salePage={salePage}
            productAdditionalInforms={productAdditionalInforms}
            interactive={interactive}
          />
        )
      ) : (
        <EndedCTA status={salePage?.saleStatus} />
      )}
    </CTA>
  );
};
